import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryVM} from "../../models/CategoryVM.model";
import {CategoryService} from "../../services/category/category.service";
import {ServantVM, ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {ServiceItemVM} from "../../models/ServiceItemVM";


@Component({
  selector: 'rw-category-service-cards-modern',  // <home></home>
  styles: [require('./category-service-cards-modern.component.scss')],
  template: require('./category-service-cards-modern.component.html')
})
export class CategoryServiceCardsModernComponent implements OnInit, OnChanges {

  @Input() public serviceList: ServiceItemVM[];
  @Input() public selectedServant: ServantVM;
  @Input() public companyKeyUrl? = null;
  public company: CompanyVM;
  public showDuration: boolean = true;
  public showPrice: boolean = true;
  public meetingType;
  themeCompanyListType : string = 'CARD';
  public isAzadTech : boolean = false;
  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute: ActivatedRoute, private companyService: CompanyService, private categoryService: CategoryService) {
  }


  private imageList: ImageVM[];

  public ngOnInit() {
    let parent = this;
    this.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((c) => {
      parent.company = c;
      let durationViewMode = parent.companyService.getCompanyCustomSetting(c, 'durationViewMode');
      let priceViewMode = parent.companyService.getCompanyCustomSetting(c, 'priceViewMode');
      // console.log('show duration mode :')
      // console.log(durationViewMode);
      if (durationViewMode && durationViewMode.toLowerCase() == 'hide')
        parent.showDuration = false;
      else
        parent.showDuration = true;
      if (priceViewMode && priceViewMode.toLowerCase() == 'hide')
        parent.showPrice = false;
      else
        parent.showPrice = true;

      if (c && c.setting && c.setting.themeSettingInfo && c.setting.themeSettingInfo.themeServiceListType)
        this.themeCompanyListType = c.setting.themeSettingInfo.themeServiceListType;


      //check azadTech -- must change in future
      if(c.keyUrl.toLowerCase() == 'azadtech')
        parent.isAzadTech = true;
      //...........................................

    })
  }

  onServiceExpanded(si) {
    let parent = this;
    if (si && !si.detail) {

      parent.categoryService.getServiceItemDetailById(si.id)
        .subscribe((sdetail) => {
          si.detail = sdetail;
          // parent.serviceList[i].meetingType = sdetail.meetingType;
          parent.setDuration(si.detail);
          parent.getServiceImage(si.detail);

        })
    }
  }

  checkSelectedServant(si) {
    if (si && this.selectedServant) {
      si.servantId = this.selectedServant.id;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
    parent.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((com) => {
      parent.company = com;
      // let i = 0;
      parent.serviceList.forEach((si) => {
        parent.onServiceExpanded(si);
        // i++;
      })
    });
  }

  getServiceImage(si: ServiceItemDetailVM) {
    let parent = this;

    if (si && si.imageAlbum && si.imageAlbum.imageList && si.imageAlbum.imageList.length > 0) {

      si.coverImage = si.imageAlbum.imageList[0];
      si.imageUrl = parent.companyService.makeImageUrl('service', si.coverImage, parent.company.activityType, false)
    } else {
      si.imageUrl = parent.companyService.makeImageUrl('service', si.coverImage, parent.company.activityType, false)
    }
  }

  setDuration(sd) {
    if (sd.scheduleInfo && sd.scheduleInfo.weeklyScheduleInfo && sd.scheduleInfo.weeklyScheduleInfo.timePeriod) {
      sd.duration = sd.scheduleInfo.weeklyScheduleInfo.timePeriod.duration;
    }
  }

  showReserveButton(si: ServiceItemDetailVM){
    if(si.serviceStatus == "RESERVE_JUST_PANEL" && this.isAzadTech)
      return false;
    else
      return true;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/category-service-cards-modern/category-service-cards-modern.component.ts